import { assert } from '@varos/util-typescript';
import { ReportingLoaderBaseConfig } from '../../../base';
import { DatabaseFilterLoader } from './databaseFilterInterface';

export function createDatabaseFilterLoader(
    config: ReportingLoaderBaseConfig
): DatabaseFilterLoader {
    const { repository } = config;
    return {
        useLoad(context, props) {
            return {
                property: props.property,
            };
        },
    };
}
